import React from 'react';
import Button from 'src/components/Button';
import Loader from 'src/components/Loader';
import './BulkActionButton.scss';

interface BulkActionButtonProps {
  actionText: string;
  isSubmitting: boolean;
  disabled: boolean;
  onClick?: () => void;
  selectedCount?: number;
  countLabel?: string;
  block?: boolean;
  submit?: boolean;
  size?: string | null;
  style?: React.CSSProperties;
}

const LoadingButton = ({
  actionText,
  isSubmitting,
  disabled,
  onClick,
  selectedCount,
  countLabel = 'Selected',
  block,
  submit,
  size = 'small',
  style,
}: BulkActionButtonProps) => {
  const labelText =
    selectedCount !== undefined
      ? `${actionText} (${selectedCount} ${countLabel})`
      : actionText;

  return (
    <Button
      color="teal"
      {...(size ? { size } : {})}
      block={block}
      submit={submit}
      label={
        <span className="bulk-action-button-content">
          {isSubmitting && (
            <Loader
              imageHeight="18px"
              imageWidth="18px"
              style={{ display: 'inline-block', margin: 0 }}
            />
          )}
          {labelText}
        </span>
      }
      disabled={disabled || isSubmitting}
      onClick={onClick}
      style={style}
    />
  );
};

export default LoadingButton;
